import { useEffect } from 'react'

const SUFFIX = 'Hourglass'

export function useDocumentTitle(title?: string) {
	useEffect(() => {
		document.title = title ? `${title} | ${SUFFIX}` : SUFFIX
	}, [title])
}
